import getLang from 'I18n/utils/getLang';
import { SEARCH_QUERY as PUBLIC_SEARCH_QUERY } from '../../../__generated__/chirp/com/hubspot/marketplace/personalization/rpc/PersonalizationPublicRpc.dfc.new';
import { SEARCH_QUERY } from '../../../__generated__/chirp/com/hubspot/marketplace/personalization/rpc/PersonalizationRpc.dfc.new';
import { useCollectionQuery } from '../../search-results/hooks/useCollectionQuery';
import { mapAppliedFiltersForRpc } from '../../search-results/utils/searchMappers';
import { useGates } from '../../hooks/useGates';
import { usePersonalizationQuery } from '../../hooks/usePersonalizationQuery';
import { useDiscoveryCollectionListings } from './useDiscoveryCollectionListings';

/**
 * Hook to fetch 6 apps from the most recent published collection
 */
export function useCollectionApps(featuredCollectionId) {
  var _recentCollection$slu, _appsQuery$data, _appsQuery$data2, _ref, _recentCollection$tit;
  const gates = useGates();
  const collectionResult = useCollectionQuery(featuredCollectionId ? {
    mode: 'id',
    collectionId: featuredCollectionId
  } : {
    mode: 'recent'
  });
  const recentCollection = collectionResult.isUmbrellaCollection ? undefined : collectionResult.data;

  // DS-backed path (NewDashboard gate)
  const dsListings = useDiscoveryCollectionListings({
    slug: (_recentCollection$slu = recentCollection === null || recentCollection === void 0 ? void 0 : recentCollection.slug) !== null && _recentCollection$slu !== void 0 ? _recentCollection$slu : '',
    productTypes: ['APP'],
    length: 6,
    skip: !gates.newDashboard
  });

  // Legacy path
  const appsQuery = usePersonalizationQuery({
    app: SEARCH_QUERY,
    public: PUBLIC_SEARCH_QUERY,
    options: {
      skip: gates.newDashboard || !(recentCollection !== null && recentCollection !== void 0 && recentCollection.id),
      variables: {
        queryType: 'ELASTIC_SEARCH',
        language: getLang(),
        collectionId: recentCollection === null || recentCollection === void 0 ? void 0 : recentCollection.id,
        offset: 0,
        length: 6,
        filter: mapAppliedFiltersForRpc([{
          field: 'PRODUCT_TYPE',
          dataType: 'STRING',
          values: ['APP']
        }])
      }
    }
  });
  const cards = gates.newDashboard ? dsListings.cards : ((_appsQuery$data = appsQuery.data) === null || _appsQuery$data === void 0 ? void 0 : _appsQuery$data.result.cards) || [];
  const queryType = gates.newDashboard ? undefined : (_appsQuery$data2 = appsQuery.data) !== null && _appsQuery$data2 !== void 0 && _appsQuery$data2.result.queryType ? String(appsQuery.data.result.queryType) : undefined;
  const hasValidCollectionData = !!(recentCollection !== null && recentCollection !== void 0 && recentCollection.id && cards.length > 0);
  return {
    cards,
    collectionId: (recentCollection === null || recentCollection === void 0 ? void 0 : recentCollection.id) || 0,
    collectionSlug: (recentCollection === null || recentCollection === void 0 ? void 0 : recentCollection.slug) || '',
    description: (recentCollection === null || recentCollection === void 0 ? void 0 : recentCollection.description) || '',
    error: gates.newDashboard ? dsListings.error : appsQuery.error,
    hasValidCollectionData,
    loading: gates.newDashboard ? collectionResult.loading || dsListings.loading : appsQuery.loading,
    queryType,
    title: (_ref = (_recentCollection$tit = recentCollection === null || recentCollection === void 0 ? void 0 : recentCollection.title) !== null && _recentCollection$tit !== void 0 ? _recentCollection$tit : recentCollection === null || recentCollection === void 0 ? void 0 : recentCollection.name) !== null && _ref !== void 0 ? _ref : ''
  };
}